import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  margin-left: 6px;
  height: 20px;
  width: 20px;
  
  &:hover {
    background-color: #dcf4fd;
  	border-radius: 60px;
	cursor: pointer;
  }
`;

export const InfoTooltip = styled.div`
  display: flex;
  align-items: center;
  visibility: hidden;
  opacity: 1;
  position: absolute;
  top: 60px;
  left: -320px;
  background: white;
  width: 368px;
  min-height: 104px;
  border: 1px grey solid;
  border-radius: 12px;
  transform: translate(0, -30%);
  white-space: normal;

  &:before,
  &:after {
    bottom: 100%;
    border: solid transparent;
    content: ' ';
    position: absolute;
    pointer-events: none;
  }

  &:before {
    border-color: rgba(194, 194, 194, 0);
    border-bottom-color: grey;
    border-width: 12px;
	left: 318px;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: white;
    border-width: 11px;
	left: 319px;
	top: -21px;
  }
`;

export const InfoTooltipText = styled.p`
  text-align: left;
  background: white;
  color: black;
  margin: 5px 10px;
`;

export const InfoIcon = styled.div`
  position: relative;
  margin-left: 5px;
  margin-bottom: 1px;

  &:hover {
	background-color: #dcf4fd;
  	border-radius: 60px;
  }
  
  &:hover ${InfoTooltip} {
	cursor: pointer;
    visibility: visible;
    opacity: 1;
  }
`;
  


// WEBPACK FOOTER //
// ./components/current-assignment-modal/assign-list/assignment/components/due-date-info/styled.js